export const ReminderTypes = {
    1: 'Voor aanvang dienst (medewerker niet op locatie)',
    2: 'Na aanvang dienst (medewerker niet op locatie)',
    3: 'Na medeweker op locatie',
    4: 'Voor einde dienst (medewerker op locatie, dienst niet afgerond)',
    5: 'Na einde dienst (medewerker op locatie, dienst niet afgerond)',
    6: 'Na afgeronde dienst'
};

export const NotificationTypes = {
    1: 'Medewerker stond bij aanvang dienst meer dan 150 meter van de dienst locatie.',
    2: 'Medewerker stond bij afronding dienst meer dan 150 meter van de dienst locatie.'
};

export const DisabledCompensationLabels = {
    pause           : 'Reiskostenvergoeding',
    travel_expense  : 'Pauzevergoedingen',
    meal            : 'Maaltijdvergoeding'
};